<template>
  <div class="main-space">
    <div class="main-title">权益中心</div>
    <div class="vip-desc">
      <div class="vip-desc-title">
        <img src="@/assets/images/info-circle-fill@2x.png" alt="" />
        <span>权益说明</span>
      </div>
      <div class="vip-desc-text">
        权益是用户享受的特权或服务，平台提供权益包括但不限于研和专属服务，还包含三方服务等内容。
      </div>
    </div>
    <div class="table-space">
      <el-table stripe style="width: 100%" :data="formList" border size="small">
        <el-table-column
          align="center"
          prop="name"
          label="展示名称"
          min-width="120"
        >
          <!-- <template slot-scope="scope">
            {{ scope.row.code_name || "-" }}
          </template> -->
        </el-table-column>
        <el-table-column
          align="center"
          prop="name"
          label="权益类型"
          min-width="120"
        >
          <template slot-scope="scope">
            {{ type[scope.row.category] || "--" }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="content"
          label="权益说明"
          min-width="240"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="supplier"
          label="权益提供商"
          min-width="120"
        >
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formList: [],
      type: {
        1: "健康服务",
        2: "功能权限",
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.$get("/vip/benefits").then((res) => {
        if (res.data.code === 1000) {
          this.formList = res.data?.data || [];
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.main-space {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  height: 100%;
  border-radius: 4px;
  padding: 20px;
  box-sizing: border-box;
}
.main-title {
  font-weight: 600;
  font-size: 16px;
}
.vip-desc {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  background: #e8f3ff;
  border-radius: 2px;
  padding: 16px;
  box-sizing: border-box;
  .vip-desc-title {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 16px;
    margin-bottom: 6px;
    img {
      width: 16px;
      height: 16px;
      margin-right: 8px;
    }
  }
  .vip-desc-text {
    font-weight: 400;
    font-size: 14px;
    margin-left: 24px;
  }
}
.table-space {
  margin-top: 20px;
}
</style>
